export default __webpack_public_path__ + "static/media/watson-2.bc12dc8b.png";